/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */

import { createAction } from '../../../modules/app/createAction';
import {
    GET_TEMPORARY_PASSWORD,
    GET_TEMPORARY_PASSWORD_FAILURE,
    GET_TEMPORARY_PASSWORD_SUCCESS,
    SUBMIT_CHANGE_PASSWORD_FORM_FAILURE,
    SUBMIT_CHANGE_PASSWORD_FORM_START,
    SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS,
} from '../constants/changePasswordConstants';
import {
    IChangePasswordFormPayload,
    IGetTemporaryPasswordAction,
    IGetTemporaryPasswordFailureAction,
    IGetTemporaryPasswordSuccessAction,
    ISubmitChangePasswordFormFailureAction,
    ISubmitChangePasswordFormStartAction,
    ISubmitChangePasswordFormSuccessAction,
} from '../types/changePasswordTypes';

/*
* -------------------------------------------
*        SUBMIT FORM ACTIONS INTERFACES
* -------------------------------------------
*/

export const submitChangePasswordFormStart =
    (payload: IChangePasswordFormPayload): ISubmitChangePasswordFormStartAction =>
    createAction(SUBMIT_CHANGE_PASSWORD_FORM_START, payload);

export const submitChangePasswordFormSuccess = (payload: any): ISubmitChangePasswordFormSuccessAction =>
    createAction(SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS, payload);

export const submitChangePasswordFormFailure = (payload: string): ISubmitChangePasswordFormFailureAction =>
    createAction(SUBMIT_CHANGE_PASSWORD_FORM_FAILURE, payload);

/*
* -------------------------------------------
*        GET TEMPORARY PASSWORD
* -------------------------------------------
*/

export const getTemporaryPassword = (): IGetTemporaryPasswordAction => createAction(GET_TEMPORARY_PASSWORD);

export const getTemporaryPasswordSuccess = (payload: any): IGetTemporaryPasswordSuccessAction =>
    createAction(GET_TEMPORARY_PASSWORD_SUCCESS, payload);

export const getTemporaryPasswordFailure = (payload: string): IGetTemporaryPasswordFailureAction =>
    createAction(GET_TEMPORARY_PASSWORD_FAILURE, payload);
